import React, { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Star } from "lucide-react";
import { toast } from "sonner";
import api from "./api";
import { useAuth } from "../context/AuthContext";

// Vista della pagina: si apre sempre la predefinita scelta dall'amministratore
export function useVistaPredefinita(pagina, lsKey, fallback) {
  const { user } = useAuth();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["viste-predefinite"], staleTime: 60000, queryFn: async () => (await api.get("/viste-predefinite")).data });
  const [scelta, setScelta] = useState(null);
  const def = data?.[pagina];
  const vista = scelta || def || localStorage.getItem(lsKey) || fallback;
  const setVista = (v) => { localStorage.setItem(lsKey, v); setScelta(v); };
  const isAdmin = ["admin", "super_admin"].includes(user?.role);
  const salva = async () => {
    try { await api.put("/viste-predefinite", { pagina, vista }); qc.invalidateQueries({ queryKey: ["viste-predefinite"] }); toast.success("Vista predefinita salvata per tutti"); } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };
  const attiva = (def || fallback) === vista;
  const bottone = isAdmin ? (
    <button type="button" onClick={salva} disabled={attiva} title={attiva ? "Questa è la vista predefinita" : "Rendi questa la vista predefinita per tutti"}
      className={`inline-flex items-center gap-1 text-[10px] font-bold rounded-full px-2 py-0.5 border transition-colors ${attiva ? "bg-amber-50 text-amber-700 border-amber-300 cursor-default" : "bg-white text-slate-500 border-slate-300 hover:bg-amber-50 hover:text-amber-700"}`} data-testid={`vista-predefinita-${pagina}`}>
      <Star size={10} className={attiva ? "fill-amber-500 text-amber-500" : ""} /> predefinita
    </button>
  ) : null;
  return [vista, setVista, bottone];
}
